module.exports = __webpack_public_path__ + "files/fed95fb2e51c358bfcac78890c60f9d4.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/places-1.png
// module id = 1613
// module chunks = 60